export const range = (_start: number, _count: number): number[] =>
  new Array(_count).fill(null).map((_, _index) => _index + _start);
